<template>
    <div class="carousel product-detail-carousel">
        <carousel :classes="classes" ref="carousel" :items="items" :options="options"
                  :show-navigation="showNavigation" :show-pagination="false"
                  @slideChange="slideChange">
            <template #slide="{ item }">
                <button v-if="item.type !== 'video'" type="button" class="product-slider-item-zoom" @click="showProductZoomModal(item.image)">
                    <svg aria-hidden="true" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        <path
                            d="M319.8 204v8c0 6.6-5.4 12-12 12h-84v84c0 6.6-5.4 12-12 12h-8c-6.6 0-12-5.4-12-12v-84h-84c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h84v-84c0-6.6 5.4-12 12-12h8c6.6 0 12 5.4 12 12v84h84c6.6 0 12 5.4 12 12zm188.5 293L497 508.3c-4.7 4.7-12.3 4.7-17 0l-129-129c-2.3-2.3-3.5-5.3-3.5-8.5v-8.5C310.6 395.7 261.7 416 208 416 93.8 416 1.5 324.9 0 210.7-1.5 93.7 93.7-1.5 210.7 0 324.9 1.5 416 93.8 416 208c0 53.7-20.3 102.6-53.7 139.5h8.5c3.2 0 6.2 1.3 8.5 3.5l129 129c4.7 4.7 4.7 12.3 0 17zM384 208c0-97.3-78.7-176-176-176S32 110.7 32 208s78.7 176 176 176 176-78.7 176-176z"></path>
                    </svg>
                </button>
                <div v-if="item.type !== 'video'" @click="showProductZoomModal(item.image)" class="product-slider-item">
                    <img class="lazyload" width="347" height="500" alt="" itemprop="image"
                         :src="item.preview"
                         :data-src="item.product" />
                </div>
                <div v-if="item.type === 'video'" class="product-slider-item">
                    <video ref="productVideo" autoplay="autoplay" :poster="item.product" controls="" preload="none" width="100%" muted="" playsinline="" id="html5_video_pr" class="lazy-hidden">
                        <source :src="item.image" type="video/mp4">
                        Ваш браузер не поддерживает HTML5 видео.
                    </video>
                </div>
            </template>
        </carousel>
        <div class="gallery-thumbs">
            <div v-for="(thumb, thumbIndex) in thumbs" :key="thumbIndex" class="thumb"
                 :class="{'active': thumbIndex === index}">
                <img :src="thumb" alt="" @click="slideTo(thumbIndex)" width="90" height="130" />
            </div>
        </div>
        <product-modal-zoom :images="items"></product-modal-zoom>
    </div>
</template>

<script>
import {mapMutations} from 'vuex';
import Carousel from "./Carousel";
import windowWidth from "../../mixins/windowWidth";

export default {
    name: "ProductDetail",
    props: {
        items: {
            type: Array,
        },
        zoom: {
            type: Boolean,
            default: () => true
        },
        classes: {
            type: String,
            default: () => ''
        },
        options: {
            type: Object,
            default: () => {}
        }
    },
    components: {
        Carousel,
    },
    mixins: [
        windowWidth,
    ],
    data() {
        return {
            index: 0,
        }
    },
    computed: {
        thumbs() {
            return this.items.map(item => item.preview);
        },
        zoomAvailable() {
            return this.windowWidth > 991 && this.zoom;
        },
        showNavigation() {
            return !(this.items.length <= 1 || ((this.windowWidth <= 1024 || this.windowWidth > 1024) && this.items.length <= 2));
        }
    },
    methods: {
        ...mapMutations('product', ['showProductZoomModal']),
        slideTo(index) {
            this.$refs.carousel.slideTo(index);
        },
        slideChange(index) {
            if (this.$refs.productVideo) {
                this.$refs.productVideo.pause();
            }

            this.index = index;
        }
    },
    updated() {
        this.index = this.$refs.carousel.activeIndex;
    }
}
</script>
